import BaseChart from 'components/BaseChart/BaseChart';
import React, { ReactNode, RefObject } from 'react';
import { Button } from 'react-bootstrap';

type BaseGraphProps = {
  chartRef?: RefObject<any>;
  option?: object | null;
  onEvents?: Record<string, (...args: any[]) => void>;
  controlsLeft?: ReactNode;
  controlsRight?: ReactNode;
  onChartReady?: (instance: any) => void;
  loading?: boolean;
  loadingMessage?: ReactNode;
  emptyMessage?: ReactNode;
  className?: string;
  notMerge?: boolean;
  height?: string | number;
  width?: string | number;
};

export const resetGraphZoom = (chartRef?: RefObject<any>) => {
  const instance = chartRef?.current?.getEchartsInstance?.();
  if (!instance) return;
  instance.dispatchAction({ type: 'restore' });
  instance.dispatchAction({ type: 'dataZoom', start: 0, end: 100 });
};

export default function BaseGraph({
  chartRef,
  option,
  onEvents,
  controlsLeft,
  controlsRight,
  onChartReady,
  loading = false,
  loadingMessage = 'Loading device data...',
  emptyMessage = 'No device selected',
  className = 'bg-primary h-100 rounded-3 overflow-hidden d-flex justify-content-center align-items-center fs-4 text-white',
  notMerge = true,
  height = '100%',
  width = '100%',
}: BaseGraphProps) {
  if (loading) {
    return (
      <div className="bg-primary h-100 rounded-3 overflow-hidden d-flex flex-column justify-content-center align-items-center text-white">
        <div className="spinner-border spinner-border-sm mb-2" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <div className="fs-5">{loadingMessage}</div>
      </div>
    );
  }

  if (!option) {
    return <div className={className}>{emptyMessage}</div>;
  }

  return (
    <BaseChart
      ref={chartRef}
      option={option}
      onEvents={onEvents}
      onChartReady={onChartReady}
      notMerge={notMerge}
      autoResize
      height={height}
      width={width}
      controlsLeft={controlsLeft}
      controlsRight={
        controlsRight ?? (
          <Button type="button" size="sm" className="m-1 px-2 py-1" onClick={() => resetGraphZoom(chartRef)}>
            Reset Zoom
          </Button>
        )
      }
    />
  );
}
